import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import type { MenuProps } from "antd";
import { Menu } from "antd";
import "./Menu.scss";
import {
  CardTick,
  Category,
  Crown1,
  Gameboy,
  Gift,
  Graph,
  ReceiptDisscount,
  Setting2,
  Setting3,
  ShopAdd,
  UserSquare,
  Tag,
  DollarCircle,
  ShieldCross,
  HomeTrendDown,
  MessageText,
} from "iconsax-react";
import { RobotFilled } from "@ant-design/icons";

import UpgradePackageModal from "../Modal/UpgradePackageModal";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: "group",
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}


// storeTypeId === 4 (Match only), Menu will show: Report( dashboard),  Member, Voucher, Store game, Setting, Request Store
const storeTypeId = localStorage.getItem("storeTypeId");
const can_view_report_income =
  localStorage.getItem("can_view_report_income") ?? "0";
const can_view_weekly_report =
  localStorage.getItem("can_view_weekly_report") ?? "0";
const can_view_machine_income =
  localStorage.getItem("can_view_machine_income") ?? "0";
const can_view_payout_report =
  localStorage.getItem("can_view_payout_report") ?? "0";
const view_staff_report = localStorage.getItem("view_staff_report") ?? "0";
const service_id = localStorage.getItem("service_id");

// role_id: 1:admin, 2:owner, 3:sales, 4:user
const user = JSON.parse(localStorage.getItem("user") || "{}");
const roleId: any = user.role_id;

/*
  Check permission for "User" - role_id === 4
  1: Report
  2: Machine
  3: Member
  4: Voucher
  5: Staff
  6: Store Game
  7: Setting
*/

const permission = user.permission;
let showReport = false;
let showMachine = false;
let showMember = false;
// let showVoucher
let showStaff = false;
let showStoreGame = false;
let showSetting = false;
let showBandit = false;
let showBot = true;

const isShowFunc = (functionId: number) => {
  if (!permission) {
    return false;
  }

  const permissionReport = permission.find(
    (item: any) => item.function_id === functionId,
  );

  if (!permissionReport) {
    return false;
  }

  return (
    permissionReport?.is_view === 1 ||
    permissionReport?.is_create === 1 ||
    permissionReport?.is_edit === 1 ||
    permissionReport?.is_delete === 1
  );
};

if (permission) {
  showReport = isShowFunc(1);
  showMachine = isShowFunc(2);
  showMember = isShowFunc(3);
  // showVoucher = isShowFunc(4)
  showStaff = isShowFunc(5);
  showStoreGame = isShowFunc(6);
  showSetting = isShowFunc(7);
  showBandit = isShowFunc(8);
  showBot = isShowFunc(9);
}

const storeManagementArray = [
  !permission || showReport
    ? Number(storeTypeId) === 4
      ? getItem("Report", "report", <Graph variant="Bulk" />, [
          getItem(
            <Link to={"/report/dashboard"} rel="noopener noreferrer">
              Dashboard
            </Link>,
            "/report/dashboard",
          ),
          getItem(
            <Link to={"/report/game"} rel="noopener noreferrer">
              Game
            </Link>,
            "/report/game",
          ),
        ])
      : getItem("Report", "report", <Graph variant="Bulk" />, [
          getItem(
            <Link to={"/report/dashboard"} rel="noopener noreferrer">
              Dashboard
            </Link>,
            "/report/dashboard",
          ),
          Number(can_view_report_income) !== 0
            ? getItem(
                <Link to={"/report/total-income"} rel="noopener noreferrer">
                  Total income
                </Link>,
                "/report/total-income",
              )
            : null,
          Number(can_view_weekly_report) !== 0
            ? getItem(
                <Link to={"/report/weekly"} rel="noopener noreferrer">
                  Weekly Report
                </Link>,
                "/report/weekly",
              )
            : null,
          Number(can_view_machine_income) !== 0
            ? getItem(
                <Link to={"/report/machine-income"} rel="noopener noreferrer">
                  Machine income
                </Link>,
                "/report/machine-income",
              )
            : null,
          Number(view_staff_report) !== 0
            ? getItem(
                <Link to={"/report/staff"} rel="noopener noreferrer">
                  Staff
                </Link>,
                "/report/staff",
              )
            : null,

          Number(can_view_payout_report) !== 0
            ? getItem(
                <Link to={"/report/payout"} rel="noopener noreferrer">
                  Payout
                </Link>,
                "/report/payout",
              )
            : null,
          getItem(
            <Link to={"/report/game"} rel="noopener noreferrer">
              Game
            </Link>,
            "/report/game",
          ),
        ])
    : null,

  // MACHINE
  (!permission || showMachine) && Number(storeTypeId) !== 4
    ? getItem(
        <Link to={"/machine"} rel="noopener noreferrer">
          Machine
        </Link>,
        "/machine",
        <Gameboy variant="Bulk" />,
      )
    : null,

  // STAFF
  (!permission || showStaff) && Number(storeTypeId) !== 4
    ? getItem("Staff", "staff", <UserSquare variant="Bulk" />, [
        getItem(
          <Link to={"/staff/manage"} rel="noopener noreferrer">
            Manage
          </Link>,
          "/staff/manage",
        ),
        getItem(
          <Link to={"/staff/cash-out"} rel="noopener noreferrer">
            Match/Cash-out
          </Link>,
          "/staff/cash-out",
        ),
      ])
    : null,

  // MEMBER
  !permission || showMember
    ? getItem(
        <Link to={"/member"} rel="noopener noreferrer">
          Member
        </Link>,
        "/member",
        <Crown1 variant="Bulk" />,
      )
    : null,
  // Bandit
  !permission || showBandit
    ? getItem(
        <Link to={"/banned"} rel="noopener noreferrer">
          Banned
        </Link>,
        "/banned",
        <ShieldCross variant="Bulk" />,
      )
    : null,
  // VOUCHER
  // !permission || showVoucher ? getItem(
  //   <Link to={'/voucher'} rel="noopener noreferrer">
  //     Voucher
  //   </Link>,
  //   '/voucher',
  //   <ReceiptDisscount variant="Bulk" />
  // ) : null,

  // STORE GAME
  !permission || showStoreGame
    ? getItem("Store Game", "store-game", <Gift variant="Bulk" />, [
        getItem(
          <Link to={"/store-game/lucky-game"} rel="noopener noreferrer">
            Lucky Game
          </Link>,
          "/store-game/lucky-game",
        ),
        getItem(
          <Link to={"/store-game/random-game"} rel="noopener noreferrer">
            Random Game
          </Link>,
          "/store-game/random-game",
        ),
      ])
    : null,
  // Bot
  !permission || showBot
    ? getItem(
        <Link
          to={"/bot-integrations"}
          rel="noopener noreferrer"
          onClick={(e) => {
            if (Number(localStorage.getItem("service_id")) !== 3) {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent("openUpgradeModal"));
            }
          }}
        >
          Bot Intergrations
        </Link>,
        "/bot-integrations",
        <RobotFilled />,
      )
    : null,
  // SETTING
  !permission || showSetting
    ? getItem(
        <Link to={"/setting"} rel="noopener noreferrer">
          Setting
        </Link>,
        "/setting",
        <Setting3 variant="Bulk" />,
      )
    : null,
];

if (roleId === 2) {
  storeManagementArray.push(
    getItem(
      <Link to={"/request-store"} rel="noopener noreferrer">
        Request Store
      </Link>,
      "/request-store",
      <ShopAdd variant="Bulk" />,
    ),
  );
}

// Tất cả Role, ngoại trừ "Seller"
const storeManagement =
  roleId !== 3
    ? getItem(
        "Store Management",
        "store-tool",
        null,
        storeManagementArray,
        "group",
      )
    : null;

const adminManagement =
  roleId === 1
    ? getItem(
        "Admin Management",
        "admin-tool",
        null,
        [
          getItem(
            <Link to={"/dashboard-admin"} rel="noopener noreferrer">
              Dashboard
            </Link>,
            "/dashboard-admin",
            <HomeTrendDown size={25} variant="Bulk" />,
          ),
          // STORE LIST
          getItem("Store list", "store-list", <Category variant="Bulk" />, [
            getItem(
              <Link to={"/store-list"} rel="noopener noreferrer">
                Live store
              </Link>,
              "/store-list",
            ),
            getItem(
              <Link to={"/store-list/owner-request"} rel="noopener noreferrer">
                Owner request
              </Link>,
              "/store-list/owner-request",
            ),
          ]),
          getItem(
            <Link to={"/list-renew"} rel="noopener noreferrer">
              Renew History
            </Link>,
            "/list-renew",
            <DollarCircle size={25} variant="Bulk" />,
          ),
          // ACCOUNT LIST
          getItem(
            "Account list",
            "account-list",
            <UserSquare variant="Bulk" />,
            [
              getItem(
                <Link to={"/account-list/owner"} rel="noopener noreferrer">
                  Owner
                </Link>,
                "/account-list/owner",
              ),
              getItem(
                <Link to={"/account-list/seller"} rel="noopener noreferrer">
                  Seller
                </Link>,
                "/account-list/seller",
              ),
            ],
          ),

          // SALES REPORT
          getItem(
            <Link to={"/sales-report"} rel="noopener noreferrer">
              Sales Report
            </Link>,
            "/sales-report",
            <Graph variant="Bulk" />,
          ),
          // Chat Bot
          getItem("Ticket", "ticket", <RobotFilled />, [
            getItem(
              <Link to={"/ticket-dashboard"} rel="noopener noreferrer">
                Dashboard
              </Link>,
              "/ticket-dashboard",
            ),
            getItem(
              <Link to={"/ticket-list"} rel="noopener noreferrer">
                Tickets
              </Link>,
              "/ticket-list",
            ),
          ]),
          // LIST PAYMENT
          getItem(
            <Link to={"/list-payment"} rel="noopener noreferrer">
              List payment
            </Link>,
            "/list-payment",
            <CardTick variant="Bulk" />,
          ),

          // SETTING TYPE
          getItem(
            <Link to={"/setting-type"} rel="noopener noreferrer">
              Setting type
            </Link>,
            "/setting-type",
            <Setting2 variant="Bulk" />,
          ),

          // LIST DEVICE
          getItem(
            <Link to={"/list-device"} rel="noopener noreferrer">
              List device
            </Link>,
            "/list-device",
            <Gameboy variant="Bulk" />,
          ),

          // DISCOUNT
          getItem(
            <Link to={"/discount"} rel="noopener noreferrer">
              Discount
            </Link>,
            "/discount",
            <Tag variant="Bulk" />,
          ),

          // ACCOUNT SETTING
          getItem(
            <Link to={"/account-setting"} rel="noopener noreferrer">
              Account setting
            </Link>,
            "/account-setting",
            <Setting2 variant="Bulk" />,
          ),
        ],
        "group",
      )
    : roleId === 3
      ? getItem(
          "Admin Management",
          "admin-tool",
          null,
          [
            // STORE LIST
            getItem("Store list", "store-list", <Category variant="Bulk" />, [
              getItem(
                <Link to={"/store-list"} rel="noopener noreferrer">
                  Live store
                </Link>,
                "/store-list",
              ),
            ]),

            // ACCOUNT LIST
            getItem(
              "Account list",
              "account-list",
              <UserSquare variant="Bulk" />,
              [
                getItem(
                  <Link to={"/account-list/owner"} rel="noopener noreferrer">
                    Owner
                  </Link>,
                  "/account-list/owner",
                ),
              ],
            ),

            // SALES REPORT
            getItem(
              <Link to={"/sales-report"} rel="noopener noreferrer">
                Sales Report
              </Link>,
              "/sales-report",
              <Graph variant="Bulk" />,
            ),

            // LIST PAYMENT
            getItem(
              <Link to={"/list-payment"} rel="noopener noreferrer">
                List payment
              </Link>,
              "/list-payment",
              <CardTick variant="Bulk" />,
            ),

            // ACCOUNT SETTING
            getItem(
              <Link to={"/account-setting"} rel="noopener noreferrer">
                Account setting
              </Link>,
              "/account-setting",
              <Setting2 variant="Bulk" />,
            ),
            getItem(
              <Link to={"/support-inbox"} rel="noopener noreferrer">
                Support Inbox
              </Link>,
              "/support-inbox",
              <MessageText variant="Bulk" />,
            ),
          ],
          "group",
        )
      : null;

const items: MenuProps["items"] = [storeManagement, adminManagement];

const WidgetMenu: React.FC = () => {
  const pathConvert = (path: string) => {
    const pathArr = path.split("/");
    let result = "";

    if (pathArr.length > 3) {
      result = [pathArr[0], pathArr[1], pathArr[2]].join("/");
    } else {
      result = path;
    }
    return result;
  };

  let location = useLocation();
  const [current, setCurrent] = useState(
    location.pathname === "/" || location.pathname === ""
      ? "/"
      : pathConvert(location.pathname),
  );
  const currentParentPath = location.pathname.split("/")[1] || "";

  const parents = [
    "staff",
    "store-game",
    "account-list",
    "store-list",
    "setting",
    "report",
  ];
  const [currentParent, setCurrentParent] = useState(
    parents.find((item) => item === currentParentPath) || "",
  );
  const redirectRole = () => {
    if (roleId === 4) {
      //user

      //báo cáo
      if (!permission || !showReport) {
        if (currentParentPath === "report") {
          window.location.href = "/";
        }
      }
      //store game
      if (!permission || !showStoreGame) {
        if (currentParentPath === "store-game") {
          window.location.href = "/";
        }
      }
      //setting
      if (!permission || !showSetting) {
        if (currentParentPath === "setting") {
          window.location.href = "/";
        }
      }
      //member
      if (!permission || !showMember) {
        if (current === "/member") {
          window.location.href = "/";
        }
      }
      //staff
      if (!permission || !showStaff) {
        if (currentParentPath === "staff") {
          window.location.href = "/";
        }
      }
      //voucher
      // if (!permission || !showVoucher) {
      //   if (current === "/voucher") {
      //     window.location.href = "/";
      //   }
      // }
      //machine
      if (!permission || !showMachine) {
        if (current === "/machine") {
          window.location.href = "/";
        }
      }
    }
  };
  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname);
      }
      const parents = [
        "staff",
        "store-game",
        "account-list",
        "store-list",
        "setting",
        "report",
      ];
      const parentName =
        parents.find((item) => item === currentParentPath) || "";
      setCurrentParent(parentName);
      //bắt quyền
      redirectRole();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, current]);

  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenModal = () => setIsUpgradeModalOpen(true);
    window.addEventListener("openUpgradeModal", handleOpenModal);
    return () => {
      window.removeEventListener("openUpgradeModal", handleOpenModal);
    };
  }, []);

  const onClick: MenuProps["onClick"] = (e) => {
    if (e.key === "/bot-integrations") {
      const serviceId = localStorage.getItem("service_id");
      if (Number(serviceId) !== 3) {
        setIsUpgradeModalOpen(true);
        return;
      }
    }
    setCurrent(e.key);
  };

  // const [collapsed, setCollapsed] = useState(false);
  // const toggleCollapsed = () => {
  //   const appElem = document.getElementsByClassName('app')[0]
  //   if (!appElem) return false
  //   appElem.classList.toggle('menu-collapsed')
  //   setCollapsed(!collapsed);
  // };

  return (
    <div className="app-menu-vertical">
      <Menu
        onClick={onClick}
        defaultSelectedKeys={[current]}
        defaultOpenKeys={[currentParent]}
        mode="inline"
        items={items}
        // inlineCollapsed={collapsed}
        className="rs-scrollbar"
        expandIcon={false}
      />
      <UpgradePackageModal
        open={isUpgradeModalOpen}
        onClose={() => setIsUpgradeModalOpen(false)}
      />
    </div>
  );
};

export default WidgetMenu;
